module.exports = __webpack_public_path__ + "img/new-logo.59267c7a.png";